import React, { PropsWithChildren } from "react";

export function DropdownBox({
  title,
  defaultOpen,
  children,
}: PropsWithChildren<{ title: string; defaultOpen: boolean }>) {
  return (
    <div className="flex flex-column options-box">
      <div className="title flex items-center">
        <div>{title}</div>
      </div>
      {defaultOpen ? children : null}
    </div>
  );
}
